import PageWithSidebar from "../PageWithSidebar";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FilterButton from "../Shared/Buttons/FilterButton";
import TrilhasConcluidas from "./TrilhasConcluidas";
import UsuariosCriados from "./UsuariosCriados";
import UsuariosPorMunicipio from "./UsuariosPorMunicipio";
import ProgressosCursos from "./ProgressosCursos";
import { useTranslation } from "react-i18next";
import {getLocalizedRoutePath, ROUTE_KEYS} from "../../routes/definitions";

export default function Relatorios({ section }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const courseProgressPath = getLocalizedRoutePath(ROUTE_KEYS.REPORTS_COURSE_PROGRESS, language);

  const isEnglish = i18n.language?.toLowerCase().startsWith("en");

  const sectionMetadata = {
    "Progresso por Curso": {
      key: "progressByCourse",
      labels: {
        pt: "Progresso por Curso",
        en: "Progress by Course",
      },
      onNavigate: () => navigate(courseProgressPath),
    },
  };

  const currentSectionMeta = sectionMetadata[section];
  const sectionKey = currentSectionMeta?.key ?? section;
  const sectionTitleFallback = currentSectionMeta
    ? currentSectionMeta.labels[isEnglish ? "en" : "pt"]
    : section;

  const reportsLabel = t("reports", {
    defaultValue: isEnglish ? "Reports" : "Relatórios",
  });

  const sectionTitle = t(sectionKey, {
    defaultValue: sectionTitleFallback,
  });

  const filterButtons = [
    {
      key: "progressByCourse",
      label: t("progressByCourse", {
        defaultValue:
          sectionMetadata["Progresso por Curso"].labels[
            isEnglish ? "en" : "pt"
          ],
      }),
      selected: sectionKey === "progressByCourse",
      onClick: sectionMetadata["Progresso por Curso"].onNavigate,
    },
  ];

  useEffect(() => {
    setLoading(true);
    const loadData = async () => {
      await new Promise((r) => setTimeout(r, 500));

      setLoading(false);
    };

    loadData();
  }, []);

  const renderSectionContent = () => {
    if (section === "Trilhas Concluídas") {
      return <TrilhasConcluidas />;
    }

    if (section === "Usuários Criados") {
      return <UsuariosCriados />;
    }

    if (sectionKey === "progressByCourse") {
      return <ProgressosCursos />;
    }

    if (section === "Usuários por município") {
      return <UsuariosPorMunicipio />;
    }

    return null;
  };

  return (
    <PageWithSidebar
      loading={loading}
      additionalClasses="flex flex-col text-playmove-darkgray"
      allowedRoles={["Admin", "PlaymoveAdmin"]}
    >
      <div className="flex flex-col">
        <div className="flex flex-row h-fit pb-5 border-b-gray-300 border-b-[3px]">
          <div className="flex flex-col">
            <p className="mt-auto text-xl font-dosisbold">{reportsLabel}</p>
            <p className="mb-auto text-2xl font-bold">{sectionTitle}</p>
          </div>
        </div>

        <div className="flex flex-wrap mt-3 justify-center md:justify-start md:flex-row gap-y-4 gap-x-3 mb-auto">
          {/* {filterButtons.map((button) => (
            <FilterButton
              key={button.key}
              text={button.label}
              selected={button.selected}
              onClick={button.onClick}
            />
          ))} */}
        </div>

        {renderSectionContent()}
      </div>
    </PageWithSidebar>
  );
}
